import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from 'utils/BackgroundJobs';
import { QuotationDocument } from 'graphql/entities';
import { getMutationProps, getRangeMutationProps } from './DocumentAction';
import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';

function onComplete(state, props, job) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onComplete, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Quotation',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    onComplete,
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
}

export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    QuotationDocument.generate,
    getMutationProps(state, props, variables),
    props,
    returnUrl,
    'Generate Quotation',
    (job) => onComplete(state, props, job)
  );
}

export function generateRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    QuotationDocument.generateRange,
    getRangeMutationProps(state, props, variables, 'salesOrders'),
    props,
    returnUrl,
    'Generate Quotation',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

/**
 * Reprints a set of quotationDocuments (Provided as an array within variables).
 */
export function reprintRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    QuotationDocument.reprint,
    getRangeMutationProps(state, props, variables, 'quotationDocuments'),
    props,
    returnUrl,
    'Generate Quotation',
    (job) => onComplete(state, props, job)
  );
}
